function initProgramFinder() {
	var $        = jQuery;

	function isMobileDevice() {
		var coarsePointer = (window.matchMedia('(pointer: coarse)')).matches,
			touchPoints   = 'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0,
			orientation   = 'orientation' in window,
			canHover      = (window.matchMedia('(any-hover: hover)')).matches;

		return coarsePointer && touchPoints && orientation && !canHover;
	}

	function supportsShowPicker() {
		let detectionEnabled   = true,
			selectElem         = document.createElement('select'),
			supportsShowPicker = 'showPicker' in selectElem && typeof selectElem.showPicker == 'function';

		return detectionEnabled && supportsShowPicker;
	}

	$('[data-js="ap-ib-tool-ui"]').each(function () {
		var UI             = $(this),
			filters        = UI.find('[data-js="ap-ib-filters"]'),
			campuses       = [],
			resultTemplate = UI.find('[data-js="result-template"]').html(),
			results        = UI.find('[data-js="results"]'),
			filterTimeout  = null,
			screenReaderAnnounce = $('#screen-reader-announce');

		function openDropdown(elem) {
			let button, dropdown;

			if (elem.is('button')) {
				button   = elem;
				dropdown = UI.find('#' + button.attr('aria-controls'));
			} else if (elem.closest('.select-dropdown').length > 0) {
				dropdown = elem.closest('.select-dropdown');
				button   = UI.find('[aria-controls="' + dropdown.attr('id') + '"]');
			}

			if (isMobileDevice() && supportsShowPicker()) { //mobile device
				let select = dropdown.next('select');

				//make the real select "visible" so that the browser will allow it to showPicker()
				select.css({
					opacity: 0,
					padding: 0,
					margin: 0,
					height: 0,
					width: 0,
					display: 'block'
				});

				select.get(0).showPicker();
			} else { //'desktop' device
				dropdown.show();

				dropdown.find('> ul').attr('tabindex', '0');
				dropdown.find('li[role="option"]').attr('tabindex', '0');

				button.attr('aria-expanded', 'true');
				button.closest('.select-wrapper').addClass('select-expanded');
			}

			button.trigger('uws-ap-ib-tool:dropdown-opened');
		}

		function closeDropdown(elem) {
			let button, dropdown;

			if (elem.is('button')) {
				button   = elem;
				dropdown = UI.find('#' + button.attr('aria-controls'));
			} else if (elem.closest('.select-dropdown').length > 0) {
				dropdown = elem.closest('.select-dropdown');
				button   = UI.find('[aria-controls="' + dropdown.attr('id') + '"]');
			}

			if (isMobileDevice() && supportsShowPicker()) { //mobile device
				let select = dropdown.next('select');

				select.css({
					opacity: '',
					padding: '',
					margin: '',
					height: '',
					width: '',
					display: 'none'
				});
			} else { //'desktop' device
				dropdown.hide();

				dropdown.find('> ul').attr('tabindex', '-1');
				dropdown.find('li[role="option"]').attr('tabindex', '-1');

				button.attr('aria-expanded', 'false');
				button.closest('.select-wrapper').removeClass('select-expanded');

				button.trigger('uws-ap-ib-tool:dropdown-closed');
			}
		}

		function closeDropdowns(which) {
			if (!which) {
				which = UI.find('[data-js="dropdown-toggle"][aria-expanded="true"]');
			}

			which.each(function () {
				let button = UI.find(this);

				closeDropdown(button);
			});
		}

		function selectFakeOption(li) {
			let id = li.attr('id') || crypto.randomUUID();

			li.attr('aria-selected', 'true');
			li.attr('id', id);
			li.closest('ul').attr('aria-activedescendent', id);
		}

		function deselectFakeOption(li) {
			let id = li.attr('id') || crypto.randomUUID();

			li.removeAttr('aria-selected');
			li.attr('id', id);
			li.closest('ul').attr('aria-activedescendent', id); //yes, even though we just deactivated it: see multiselect: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/listbox_role#required_javascript_features
		}

		function selectRealOption(option) {
			let select         = option.closest('select'),
				selectedValues = [];

			option.prop('selected', true);
			option.attr('selected', 'true');
			
			select.find('option:selected').each(function () {
				selectedValues.push($(this).val());
			});
			select.val(selectedValues);

			select.trigger('change', {updateFakeSelect: false});
		}

		function deselectRealOption(option) {
			let select         = option.closest('select'),
				selectedValues = [];

			option.prop('selected', false);
			option.removeAttr('selected');
			
			select.find('option:selected').each(function () {
				selectedValues.push($(this).val());
			});
			select.val(selectedValues);

			select.trigger('change', {updateFakeSelect: false});
		}

		function addAppliedFilter(option) {
			let type, value, label, typeLabel;

			type = option.closest('select[multiple]').attr('name');

			value = option.val();
			label = option.text();
			typeLabel = UI.find('[data-js="dropdown-toggle"][aria-controls="' + option.closest('select[multiple]').prev('.select-dropdown').attr('id') + '"]').data('applied-type-label');

			if (UI.find('[data-js="applied-filters"] [data-js="applied-filter"][data-type="' + type + '"][data-value="' + value + '"]').length == 0) {
				UI.find('[data-js="applied-filters"] .af-inner').append(
					'<div class="col-auto" data-js="applied-filter" data-type="' + type + '" data-value="' + value + '">' +
						'<button class="af" id="" aria-label="Remove ' + label + '">' +
							'<span class="filter-type">' + typeLabel + '</span>' +
							'<span class="filter-value">' + label + '</span>' +
						'</button>' +
					'</div>'
				);
			}

			UI.find('[data-js="applied-filters"]:not(:visible)').show();
		}

		function removeAppliedFilter(option) {
			let type, value, label;

			if (option.is('option')) {
				type = option.closest('select[multiple]').attr('name');
				value = option.val();

				UI.find('[data-js="applied-filters"] [data-js="applied-filter"][data-type="' + type + '"][data-value="' + value + '"]').remove();
			}

			if (UI.find('[data-js="applied-filters"] [data-js="applied-filter"]').length < 1) {
				UI.find('[data-js="applied-filters"]').hide();
			}
		}

		function getRealOption(li) {
			let dropdown = li.closest('.select-dropdown'),
				select   = dropdown.next('select'),
				option   = select.find('option[value="' + li.data('value') + '"]');

			return option;
		}

		function getFakeOption(option) {
			let select   = option.closest('select'),
				dropdown = select.prev('.select-dropdown'),
				li       = dropdown.find('li[data-value="' + option.val() + '"]');

			return li;
		}

		function getButton(option_or_li) {
			if (!option_or_li.is('li')) {
				option_or_li = getFakeOption(option_or_li);
			}

			return UI.find('[aria-controls="' + option_or_li.closest('.select-dropdown').attr('id') + '"]');
		}

		function displayResults() {
			let filteredCampuses = [],
				formSerialized   = filters.serializeArray(),
				filterValues     = {},
				rowCount         = 0;

			//process the serialized form a little
			for (let i = 0; i < formSerialized.length; i++) {
				let filter = formSerialized[i];

				if (filter.name == 'search' && filter.value == '') {
					continue;
				}

				if (!filterValues[filter.name]) {
					filterValues[filter.name] = [];
				}

				if (filter.name == 'level' && filter.value.includes(',')) {
					let values = filter.value.split(',');

					for (let j = 0; j < values.length; j++) {
						filterValues[filter.name].push(values[j]);
					}
				} else {
					filterValues[filter.name].push(filter.value);
				}
			}

			if (Object.keys(filterValues).length > 0) {
				//filter results, then display
				for (let i = 0; i < campuses.length; i++) {
					let candidateCampus = campuses[i];


					if (filterValues.campus) {
						let found = false;

						for (let j = 0; j < filterValues.campus.length; j++) {
							let value = filterValues.campus[j];

							if (candidateCampus.ID == value) {
								found = true;
								break;
							}
						}

						if (!found) {
							continue;
						}
					}


					if (filterValues['ap-exams']) {
						let found = false,
							matchingExams = {};

						candidateCampus = { ...candidateCampus}; //shallow clone it so we don't modify the original

						for (let j = 0; j < filterValues['ap-exams'].length; j++) {
							let value      = filterValues['ap-exams'][j],
								valueParts = value.split('|'),
								group      = valueParts[0];

							if (candidateCampus.ap_exams[group] && candidateCampus.ap_exams[group].exams.length > 0) {

								for (let k = 0; k < candidateCampus.ap_exams[group].exams.length; k++) {

									if (candidateCampus.ap_exams[group].exams[k].exam.value == value) {

										if (!matchingExams.hasOwnProperty(group)) {
											matchingExams[group] = {
												label: candidateCampus.ap_exams[group].label,
												exams: []
											}
										}

										matchingExams[group].exams.push(candidateCampus.ap_exams[group].exams[k]);

										found = true;
									}
								}
							}
						}

						candidateCampus.ap_exams = matchingExams;

						if (!found && !filterValues['ib-exams']) {
							continue;
						}

					} else if (filterValues['ib-exams']) {
						candidateCampus = { ...candidateCampus};
						candidateCampus.ap_exams = {}; //clear out if filtering on IB Exams and not AP Exams
					}


					if (filterValues['ib-exams']) {
						let found = false,
							matchingExams = [];

						candidateCampus = { ...candidateCampus}; //shallow clone it so we don't modify the original

						for (let j = 0; j < filterValues['ib-exams'].length; j++) {
							let value = filterValues['ib-exams'][j];

							for (let k = 0; k < candidateCampus.ib_exams.length; k++) {

								if (candidateCampus.ib_exams[k].exam.value == value) {
									matchingExams.push(candidateCampus.ib_exams[k]);
									found = true;
								}
							}
						}

						candidateCampus.ib_exams = matchingExams;

						if (!found && !filterValues['ap-exams']) {
							continue;
						}
					} else if (filterValues['ap-exams']) {
						candidateCampus = { ...candidateCampus};
						candidateCampus.ib_exams = []; //clear out if filtering on AP Exams and not IB Exams
					}

					filteredCampuses.push(candidateCampus);
				}
			}

			results.find('[data-js="result"]').remove();

			for (let i = 0; i < filteredCampuses.length; i++) {
				let campus = { ...filteredCampuses[i]};

				results.append(ejs.render(resultTemplate, campus));
			}

			if (filteredCampuses.length > 0) {
				results.show();
			} else {
				results.hide();
			}

			for (let i = 0; i < filteredCampuses.length; i++) {
				for (const key in filteredCampuses[i].ap_exams) {
					if (Array.isArray(filteredCampuses[i].ap_exams[key].exams)) {
						rowCount += filteredCampuses[i].ap_exams[key].exams.length;
					}
				}

				if (Array.isArray(filteredCampuses[i].ib_exams)) {
					rowCount += filteredCampuses[i].ib_exams.length;
				}
			}

			screenReaderAnnounce.text('Displaying ' + rowCount + ' result' + (rowCount !== 1 ? 's' : ''));
		}

		//show/hide dropdown
		UI.on('click', '[data-js="dropdown-toggle"]', function (e) {

			let button = $(this),
				dropdown = $('#' + button.attr('for'));

			//close others
			$('[data-js="dropdown-toggle"]').not(button).each(function () {
				let otherButton = $(this);

				closeDropdown(otherButton);
			});

			//toggle this one
			if (button.attr('aria-expanded') == 'true') {
				closeDropdown(button);
			} else {
				openDropdown(button);
			}

			//if keyboard "click", focus the dropdown
			if (e.detail === 0) {
				dropdown.find('> ul').focus();
			}
		});

		UI.on("click keydown", '[data-js="ap-ib-filters"] .select-dropdown li[role="option"]', function (e) {
			let li       = $(this),
				option   = getRealOption(li),
				button   = getButton(li);

			if (e.type == 'keydown' && e.which !== 13) {
				return;
			}

			if (li.is('[aria-selected="true"]')) {
				deselectFakeOption(li);

				deselectRealOption(option);
			} else {
				selectFakeOption(li);

				selectRealOption(option);
			}

			closeDropdown(button);
		});

		//toggle options without ctrl/shift clicking
		UI.on('change', '[data-js="ap-ib-filters"] select[multiple]', function (event, args) {

			let select, currentSelections, previousSelections, same, added, removed;

			if (event.ctrlKey || event.metaKey) {
				return;
			}

			select = $(this);
			currentSelections  = new Set(select.val());
			previousSelections = new Set(select.data('previous') || []);

			same = previousSelections.intersection(currentSelections);
			added = currentSelections.difference(same);
			removed = previousSelections.difference(same);

			select.data('previous', select.val());

			added.forEach(function (value) {
				let option = select.find('option[value="' + value + '"]');

				option.trigger('uws-ap-ib-tool:filter-added');

				if (!args || (!("updateFakeSelect" in args) || args.updateFakeSelect)) {
					selectFakeOption(getFakeOption(option));
				}

				addAppliedFilter(option);
			});

			removed.forEach(function (value) {
				let option = select.find('option[value="' + value + '"]');
				
				option.trigger('uws-ap-ib-tool:filter-removed');

				if (!args || (!("updateFakeSelect" in args) || args.updateFakeSelect)) {
					deselectFakeOption(getFakeOption(option));
				}

				removeAppliedFilter(option);
			});
		});

		//close dropdowns when clicking off them
		$('body').on('click', function (e) {
			let target = $(e.target);

			if (target.closest('[data-js="dropdown-toggle"], .select-dropdown').length == 0) {
				closeDropdowns();
			}
		});

		UI.on('submit', '[data-js="ap-ib-filters"]', function () {
			displayResults();
			return false;
		});

		UI.on('click', '[data-js="applied-filters"] [data-js="applied-filter"]', function () {
			let appliedFilter = $(this),
				type = appliedFilter.data('type'),
				value = appliedFilter.data('value'),
				option = UI.find('[data-js="ap-ib-filters"] select[multiple][name="' + type + '"] option[value="' + value + '"]');

			deselectRealOption(option);
			deselectFakeOption(getFakeOption(option));
		});

		UI.on('uws-ap-ib-tool:filter-added uws-ap-ib-tool:filter-removed', function () {
			clearTimeout(filterTimeout);

			displayResults();
		});
		UI.on('keyup', '[data-js="search-input"]', function () {
			clearTimeout(filterTimeout);

			filterTimeout = setTimeout(function () {
				displayResults();
			}, 500);
		});

		campuses = results.data('results-data');
	});
}

initProgramFinder();